
// This model is responsible for signaling whether to load un-critical data

var Model = require("../types/Model.js");

var CHECK_DELAY = 4 * 1000; // Wait 4 seconds before checking if we're in a call

module.exports = Model({
	name: "loadchecker",
	init: init,
	uninit: uninit,
	listeners: listeners,

	_has_checked: false,
	_has_unchecked: false,
	_state: "loading",
	_check_timeout: null,

	notify_load: notify_load,
});

function init(){
	this.push(false);
	this._check_timeout = setTimeout(do_check.bind(this), CHECK_DELAY);
}

function uninit() {
	clearTimeout(this._check_timeout);
}

function listeners() {
	return {
		"calling:updated": handle_calling_update
	};
}

function handle_calling_update(calling) {
	if(this._has_unchecked) return;
	var state = calling.state;
	this._state = state;
	if(this._has_checked) {
		if(state !== "idle") return;
		this.notify_load();
	}
}

function do_check() {
	var state = this._state;
	if(state === "idle")
		this.notify_load();
	else this._has_checked = true;
}

function notify_load() {
	this._has_unchecked = true;
	this.push(true);
	this.dispatch("ready");
}
